/**
 * Formata o responsável de um log de integração.
 * @param {{ userId: number|null, user: { name: string }|null }} item
 * @returns {string}
 */
export function formatResponsavel(item) {
  if (item.userId === null || item.userId === undefined) return '-';
  if (item.userId === 0) return 'Sistema';
  return item.userId + ' - ' + (item.user && item.user.name);
}
